import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const ProductIdv16 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={16}
    contrast={contrast}
    className={className}
  >
    <g clipPath='url(#clip0_1_419)'>
      <path
        d='M2.25 2.25H4.75V0.75H1.96429C1.29365 0.75 0.75 1.29365 0.75 1.96429V4.75H2.25V2.25Z'
        fill='currentColor'
      />
      <path
        d='M13.75 2.25H11.25V0.75H14.0357C14.7063 0.75 15.25 1.29366 15.25 1.96429V4.75H13.75V2.25Z'
        fill='currentColor'
      />
      <path
        d='M2.25 13.75V11.25H0.75V14.0357C0.75 14.7063 1.29366 15.25 1.96429 15.25H4.75V13.75H2.25Z'
        fill='currentColor'
      />
      <path
        d='M13.75 13.75V11.25H15.25V14.0357C15.25 14.7063 14.7063 15.25 14.0357 15.25H11.25V13.75H13.75Z'
        fill='currentColor'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M5.5 6.25C5.5 4.86929 6.61929 3.75 8 3.75C9.38071 3.75 10.5 4.86929 10.5 6.25C10.5 7.0678 10.1073 7.79389 9.50024 8.25C11.0189 8.25013 12.25 9.4813 12.25 11V11.5H10.75V11C10.75 10.3096 10.1904 9.75 9.5 9.75H6.5C5.80964 9.75 5.25 10.3096 5.25 11V11.5H3.75V11C3.75 9.4813 4.98108 8.25013 6.49976 8.25C5.89267 7.79389 5.5 7.0678 5.5 6.25ZM8 5.25C7.44772 5.25 7 5.69772 7 6.25C7 6.80228 7.44772 7.25 8 7.25C8.55228 7.25 9 6.80228 9 6.25C9 5.69772 8.55228 5.25 8 5.25Z'
        fill='currentColor'
      />
    </g>
    <defs>
      <clipPath id='clip0_1_419'>
        <rect width='16' height='16' fill='white' />
      </clipPath>
    </defs>
  </Svg>
);

ProductIdv16.displayName = 'ProductIdv16';
export default ProductIdv16;
